<template>
  <div>
    <list row-key="id" ref="list" unit="订单统计" :query-params="params" item-name="Items" item-name2="Items" :layout="layout" size="small" show-summary
      :summary-method="summaryMethod" :is-merge="isMerge" :center-title="centerTitle" :show-query="showQuery" :get-data-func="getDataFunc" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="toPrint">打印</el-button>
      </template>
      <template slot="query">
        <el-form-item label="订单编号">
          <el-input v-model="OrderNo" class="long_inp" placeholder="请选择" @focus="openSalePick" readonly/>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="FullName" class="long_inp" placeholder="请选择" @focus="openUnitPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="产品批号">
          <el-input v-model="BatchNumber" class="long_inp" placeholder="请选择" @focus="openBatchPick" readonly />
        </el-form-item>
        <el-form-item label="成品编码">
          <el-input v-model="ProductNo" class="long_inp" placeholder="请选择" @focus="openProductPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="商标编码">
          <el-input v-model="trademarkNo" class="long_inp" placeholder="请选择" @focus="openTrademarkPick" readonly />
        </el-form-item>
        <el-form-item label="颜色编码">
          <el-input v-model="Color" class="long_inp" placeholder="请选择" @focus="openColorPick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="订货日期" style="margin-right: 219px;">
          <el-date-picker
            class="range-picker"
            v-model="OrderDateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChange"
            clearable
            style="width: 180px!important"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预计出货日期">
          <el-date-picker
            class="range-picker"
            v-model="yjchrq"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChange2"
            clearable
            style="width: 180px!important"
          ></el-date-picker>
        </el-form-item>
        <br>
        <el-form-item label="入库日期" style="margin-right: 219px;">
          <el-date-picker
            class="range-picker"
            v-model="rkrq"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="onChange3"
            clearable
            style="width: 180px!important"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="查询分组方式">
          <el-radio-group v-model="params.GroupType">
            <el-radio :label="0">按客户</el-radio>
            <el-radio :label="1">按订单</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="BatchNumber" label="产品批号" min-width="180px" />
        <el-table-column prop="BarCode" label="成品条码" min-width="120px" />
        <el-table-column prop="ColorName" label="颜色" />
        <el-table-column prop="TrademarkName" label="商标" />
        <el-table-column prop="" label="跟单员工" />
        <el-table-column prop="" label="业务员工" />
        <el-table-column prop="UnitName" label="单位" />
        <el-table-column prop="OrderQuantity" label="订货数量" />
        <el-table-column prop="DeliveryQuantity" label="发货数量" />
        <el-table-column prop="" label="每件数" />
        <el-table-column prop="" label="发货箱数" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <multi-pick-dialog ref="saleMultiPick" in-dialog @select-multiple="setOrderNo" title="订单列表" key-id="OrderId" key-name="订单编号" key-value="OrderNo"
     :func="saApi.docList" second-name="客户名称" second-value="FullName" :default-value="orderNoArr" />
    <multi-pick-dialog ref="unitMultiPick" in-dialog @select-multiple="setUnit" title="客户列表" key-id="TradeUnitId" key-name="客户名称" key-value="FullName"
     :func="unitApi.list" :params="{TradeUnitTypes:[0,2]}" second-name="客户编号" second-value="TradeUnitNo" :default-value="unitArr" />
    <multi-pick-dialog ref="batchMultiPick" in-dialog @select-multiple="setBatch" title="产品批号列表" key-id="BatchId" key-name="产品批号" key-value="BatchNumber"
     :func="proApi.batchNumberList" :default-value="batchArr" />
    <multi-pick-dialog ref="productMultiPick" in-dialog @select-multiple="setProduct" title="成品编码列表" key-id="ProductId" key-name="成品编码" key-value="ProductNo"
     :func="proApi.list" second-name="成品名称" second-value="ProductName" :default-value="productArr" />
    <multi-pick-dialog ref="trademarkMultiPick" in-dialog @select-multiple="setTrademark" title="商标列表" key-id="TrademarkId" key-name="商标编码" key-value="TrademarkNo"
     :func="trademarkApi.list" second-name="商标名称" second-value="TrademarkName" :default-value="trademarkArr" :params="{ Status:1 }" />
    <multi-pick-dialog ref="colorMultiPick" in-dialog @select-multiple="setColor" title="颜色列表" key-id="ColorId" key-name="颜色名称" key-value="ColorName"
     :func="colorApi.list" second-name="颜色编码" second-value="ColorNo" :default-value="colorArr" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list,multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，params接口参数传对象，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局
  data() {
    return {
      api: require("@/api/statistics/rep").default,
      saApi: require('@/api/sa/saOrder').default,
      unitApi: require('@/api/ba/tradeUnit').default,
      colorApi: require('@/api/ba/color').default,
      proApi: require('@/api/ba/product').default,
      trademarkApi: require('@/api/ba/trademark').default,
      params: {
        ListOrderNo: [],
        ListTradeUnitName: [],
        ListBatchNumber: [],
        ListProductNo: [],
        ListTrademarkNo: [],
        ListColor: [],
        OrderDateBegin: "",
        OrderDateEnd: "",
        OutDateBegin: "",
        OutDateEnd: "",
        InDataBegin: "",
        InDateEnd: "",
        GroupType: 0,
      },
      OrderDateRange: [],
      yjchrq: [],
      rkrq: [],
      //---
      OrderNo: "",
      orderNoArr: [],
      //---
      FullName: "",
      unitArr: [],
      //---
      BatchNumber: "",
      batchArr: [],
      //---
      ProductNo: "",
      productArr: [],
      //---
      trademarkNo: "",
      trademarkArr: [],
      //---
      Color: "",
      colorArr: [],
      //---
      isMerge: false,
      centerTitle: "",
    };
  },
  computed: {
    layout() {
      return [
        { name: "客户编号", key: "TradeUnitNo", span: 6, isMain: true },
        { name: "客户名称", key: "TradeUnitName", span: 18, isMain: true },
        { name: "订单单号", key: "OrderNo", span: 6 },
        { name: "制单员工", key: "MakeEmpName", span: 5 },
        { name: "订单日期", key: "OrderDate", span: 6, isDate: true },
        { name: "预定出货日期", key: "DeliveryDate", span: 7, isDate: true },
      ];
    }
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.isMerge = params.GroupType == 0;
        this.api.repOrderSum(this.$commonJs.obj.removeNullKey(params)).then((res) => {
          this.centerTitle = params.GroupType==0?"生产统计（按客户合计）":"生产统计（按订单合计）";
          resolve(res);
        });
      });
    },
    openSalePick() {
      this.$refs.saleMultiPick.open();
    },
    openUnitPick() {
      this.$refs.unitMultiPick.open();
    },
    openBatchPick() {
      this.$refs.batchMultiPick.open();
    },
    openProductPick() {
      this.$refs.productMultiPick.open();
    },
    openTrademarkPick() {
      this.$refs.trademarkMultiPick.open();
    },
    openColorPick() {
      this.$refs.colorMultiPick.open();
    },
    setOrderNo(e,n) {
      this.orderNoArr = e;
      this.OrderNo = n;
      this.params.ListOrderNo = n?n.split(","):[];
    },
    setUnit(e,n) {
      this.unitArr = e;
      this.FullName = n;
      this.params.ListTradeUnitName = n?n.split(","):[];
    },
    setBatch(e,n) {
      this.batchArr = e;
      this.BatchNumber = n;
      this.params.ListBatchNumber = n?n.split(","):[];
    },
    setProduct(e,n) {
      this.productArr = e;
      this.ProductNo = n;
      this.params.ListProductNo = n?n.split(","):[];
    },
    setTrademark(e,n) {
      this.trademarkArr = e;
      this.trademarkNo = n;
      this.params.ListTrademarkNo = n?n.split(","):[];
    },
    setColor(e,n) {
      this.colorArr = e;
      this.Color = (e.map(x => {return x.ColorNo})).join(",");
      this.params.ListColor = n?n.split(","):[];
    },
    onChange(e) {
      this.params.OrderDateBegin = e?e[0]:"";
      this.params.OrderDateEnd = e?e[1]:"";
    },
    onChange2(e) {
      this.params.OutDateBegin = e?e[0]:"";
      this.params.OutDateEnd = e?e[1]:"";
    },
    onChange3(e) {
      this.params.InDataBegin = e?e[0]:"";
      this.params.InDateEnd = e?e[1]:"";
    },
    reset() {
      let today = this.$commonJs.getToday();
      this.OrderDateRange = [today.substr(0,8) + "01",today];
      this.params.OrderDateBegin = today.substr(0,8) + "01";
      this.params.OrderDateEnd = today;
      this.yjchrq = [];
      this.rkrq = [];
      //----
      this.OrderNo = "";
      this.orderNoArr = [];
      //----
      this.FullName = "";
      this.unitArr = [];
      //----
      this.BatchNumber = "";
      this.batchArr = [];
      //----
      this.ProductNo = "";
      this.productArr = [];
      //---
      this.trademarkNo = "";
      this.trademarkArr = [];
      //----
      this.Color = "";
      this.colorArr = [];
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小计';
          return;
        } else if(index > 6) {
        // } else if(arr.indexOf(column.label) > -1) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index]);
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    toPrint() {
      let list = this.$refs.list;
      let path = list.tempQueryParams.GroupType==0?"/orderStatisticPrint":"/orderStatisticPrint2";
      sessionStorage.setItem(path,JSON.stringify(list.data));
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>